import {
    createBrowserRouter,
    Navigate,
    Outlet,
    ScrollRestoration,
    useLocation,
} from "react-router";
import { SunProtectionPage } from "@/pages/sun-protection/SunProtectionPage";
import { OrderConfirmationPage } from "@/pages/order-confirmation/OrderConfirmationPage";
import { OrderPlacedPage } from "@/pages/order-placed/OrderPlacedPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

function RootRedirect() {
    const { search } = useLocation();
    return <Navigate to={`/zonwering${search}`} replace />;
}

function RootLayout() {
    return (
        <>
            <ScrollRestoration />
            <Outlet />
        </>
    );
}

export const router = createBrowserRouter([
    {
        element: <RootLayout />,
        children: [
            {
                path: "/",
                element: <RootRedirect />,
            },
            {
                path: "/zonwering",
                element: <SunProtectionPage />,
            },
            {
                path: "/zonwering/bestelling-bevestigen",
                element: <OrderConfirmationPage />,
            },
            {
                path: "/zonwering/bedankt",
                element: <OrderPlacedPage />,
            },
            {
                path: "*",
                element: <NotFoundPage />,
            },
        ],
    },
]);
